import DetailPrice from "./DetailPrice";
import DetailTitle from "./DetailTitle";

import { useMemo } from "react";
import parlorDetailType from "types/parlorDetailType";
import { VStack } from "goi_common";

interface FuneralProps {
  parlor: parlorDetailType;
}

function Funeral({ parlor }: FuneralProps) {
  const { id, name, sum, results } = useMemo<parlorDetailType>(() => {
    return parlor;
  }, [parlor]);

  return (
    <VStack width="100%" alignItems="center">
      <VStack maxWidth="720px" width="100%">
        <DetailTitle parlorId={id} name={name} sum={sum} />

        <DetailPrice results={results} />
      </VStack>
    </VStack>
  );
}

export default Funeral;
